import React, { useState } from "react";
import { faCalendarAlt, faUser, faMoneyCheck, faMoneyBillWave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { uploadCheque } from "../../Redux/Actions/BillingsActions";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import axios from "axios";

const ProcessCheque = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation();
    const { id } = useParams()
    const { billingData } = location.state || {};

    const [selectedFile, setSelectedFile] = useState(null);
    const [showProcess, setShowProcess] = useState(false)
    const [imagePreview, setImagePreview] = useState(null);
    const [textResult, setTextResult] = useState('');

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const handleUpload = () => {
        if (!selectedFile) {
            toast.error('Please select a file.')
            return
        };
        const formData = new FormData();
        formData.append('billing_id', id)
        formData.append('cheque_file', selectedFile)

        dispatch(uploadCheque(formData)).then((res) => {
            if (res?.type === "upload-cheque/fulfilled") {
                toast.success(res?.payload?.message)
                setShowProcess(true)
            } else {
                toast.error('Error Occured')
                setShowProcess(false)
            }
        })
    };

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64 = reader.result.split(',')[1]; // remove the data:image/... header
                resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };

    const handleProcess = async () => {
        if (!selectedFile) return;

        const fileType = selectedFile.type;

        // For images
        if (fileType.startsWith("image/")) {
            try {
                const base64 = await convertFileToBase64(selectedFile);

                const response = await axios.post(
                    `https://vision.googleapis.com/v1/images:annotate?key=b9946c83855f6a84546a82110a4357aee049159f`,
                    {
                        requests: [
                            {
                                image: {
                                    content: base64,
                                },
                                // features: [{ type: "TEXT_DETECTION" }],
                            },
                        ],
                    }
                );
                const detectedText =
                    response.data.responses[0].fullTextAnnotation?.text || "No text found";
            } catch (error) {
                console.error("Image text detection failed:", error);
            }
        }
    };


    const handleBack = () => {
        navigate('/dashboard/billinglisting')
    }

    const totalPaid = billingData?.billing_data?.filter((item) => item?.status === 'paid');
    const totalAmount = totalPaid?.reduce((sum, item) => sum + Number(item.amount || 0), 0);
    return (
        <div className="min-h-screen bg-gradient-to-tr from-white to-gray-100 p-4">
            <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-2xl p-10">
                <h2 className="text-3xl font-bold text-gray-800 text-center mb-6">Cheque Details Review</h2>

                <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg mb-6 text-blue-800">
                    Please review the cheque details below. If something doesn't look right, re-upload and process again.
                    <br />
                    If everything looks good, you can proceed by clicking the <strong>Process</strong> button.
                </div>




                {/* Cheque Info Grid */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                    <div>
                        <label className="text-sm text-gray-600 mb-1 block">Client Name</label>
                        <div className="border border-gray-200 bg-gray-50 rounded-lg p-2 font-medium text-gray-800">
                            {billingData?.client?.name}
                        </div>
                    </div>
                    <div>
                        <label className="text-sm text-gray-600 mb-1 block">Month</label>
                        <div className="border border-gray-200 bg-gray-50 rounded-lg p-2 font-medium text-gray-800">
                            {billingData?.month}
                        </div>
                    </div>
                    <div>
                        <label className="text-sm text-gray-600 mb-1 block">Year</label>
                        <div className="border border-gray-200 bg-gray-50 rounded-lg p-2 font-medium text-gray-800">
                            {billingData?.year}
                        </div>
                    </div>
                    <div>
                        <label className="text-sm text-gray-600 mb-1 block">Cheque Number</label>
                        <div className="border border-gray-200 bg-gray-50 rounded-lg p-2 font-medium text-gray-800">
                            {billingData?.cheque_number || '--'}
                        </div>
                    </div>
                    <div>
                        <label className="text-sm text-gray-600 mb-1 block">Cheque Date</label>
                        <div className="border border-gray-200 bg-gray-50 rounded-lg p-2 font-medium text-gray-800">
                            {new Date(billingData?.cheque_date)?.toLocaleDateString('en-GB')}
                        </div>
                    </div>
                    <div>
                        <label className="text-sm text-gray-600 mb-1 block">Total Amount</label>
                        <div className="border border-gray-200 bg-gray-50 rounded-lg p-2 font-medium text-gray-800">
                            $ {totalAmount || '--'}
                        </div>
                    </div>
                    <div>
                        <label className="text-sm text-gray-600 mb-1 block">Cheque Processed</label>
                        <div className="border border-gray-200 bg-gray-50 rounded-lg p-2 font-medium text-gray-800">
                            {billingData?.cheque_processed || '--'}
                        </div>
                    </div>
                </div>
                {/* Upload Section */}
                <div className="mb-5 mt-3">
                    <label className="block text-gray-700 font-medium mb-2">Upload Cheque</label>
                    <input
                        type="file"
                        accept="image/*,application/pdf"
                        onChange={handleFileChange}
                        className="w-full cursor-pointer text-gray-700 border border-gray-300 rounded-lg file:bg-indigo-100 file:text-indigo-800 file:font-semibold file:py-2 file:px-4 hover:file:bg-indigo-200"
                    />
                    {selectedFile && (
                        <p className="mt-2 text-sm text-gray-600">Selected File: <strong>{selectedFile.name}</strong></p>
                    )}
                </div>
                <div className="flex justify-end gap-4 mt-10">
                    <button className="px-5 py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-md transition" onClick={handleBack}>Back</button>
                    <button onClick={handleUpload} className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-2 px-6 rounded-lg shadow transition-all">
                        Re-Upload & ✅ Process Cheque
                    </button>
                    {/* {showProcess && (
                        <button
                            onClick={handleProcess}
                            className="px-5 py-2 rounded-xl bg-green-600 text-white font-semibold hover:bg-green-700 hover:shadow-lg transition-all"
                        >
                            ✅ Process Cheque
                        </button>
                    )} */}
                </div>
            </div>
        </div >
    );
};

export default ProcessCheque;
